import form_validation from "./form-validation";

const formSanitizer = {
  emailInput: (input) => {
    input.addEventListener("keydown", (event) => {
      if (event.code === "Space") {
        event.preventDefault();
        event.target.value = event.target.value.trim();
      }
    });
  },
};

const captchaCheck = (success) => {
  if (success) {
    return success;
  } else {
    alert("Please verify that you are not a robot.");
    return false;
  }
};
const formValidation = (form) => {
  /*----//  Get Inputs Fields  //----*/
  const formInput = form.querySelectorAll("input");
  /*----//  Get Select Fields  //----*/
  const formSelect = form.querySelectorAll("select");
  /*----//  Get Textarea Fields  //----*/
  const formTextArea = form.querySelectorAll("textarea");
  /*----//  Array of our form fields  //----*/
  const formFields = [formInput, formSelect, formTextArea];
  /*----//  Add validation  //----*/
  formFields.forEach((fields) => {
    fields.forEach((fieldEl) => {
      const inputFieldType = fieldEl.dataset.inputField;
      /*----//  Start Form Sanitization  //----*/
      if (inputFieldType === `email`) {
        formSanitizer.emailInput(fieldEl);
      }
      fieldEl.addEventListener("blur", (event) => {
        const oldfield = event.target.dataset.inputField;
        form_validation.formValidationHandler(oldfield, event.target);
      });
    });
  });
};

const finalValidation = (event) => {
  return new Promise(async (resolve, reject) => {
    try {
      const form = event.target;
      const validateFormData = await form_validation.preSubmitValidate(form);
      if (validateFormData.info && validateFormData.message) {
        if (validateFormData.info === true) {
          const formData = new FormData(form);
          const recaptchaSuccess = formData.get("g-recaptcha-response") !== "";
          if (recaptchaSuccess) {
            resolve(true);
          } else {
            captchaCheck(false);
            throw new Error(`Captcha failed`);
          }
        } else {
          throw new Error(`No form info`);
        }
      } else {
        throw new Error(`No form data`);
      }
    } catch (error) {
      event.preventDefault();
      console.error(error);
      reject(false);
    }
  });
};
const form_function = { formValidation, finalValidation };

export default form_function;
